<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import { COMPONENT_API } from "@/config/social-api";

export default {
  components: { Layout, PageHeader },
  data() {
    return {
      title: "违规与申诉",
      appid: "",
      userinfo: {},
      items: [],
      illegalLoading: false,
      illegalRecords: [],
      illegalErr: "",
      dateRange: null,
      appealDialogVisible: false,
      appealLoading: false,
      appealRecords: [],
      appealErr: "",
      currentIllegalId: "",
    };
  },
  mounted() {
    try {
      this.userinfo = JSON.parse(localStorage.getItem("user") || "{}");
    } catch (e) {
      this.userinfo = {};
    }
    this.appid = this.$route.params.appid;
    this.setBreadcrumb();
    this.loadIllegal();
  },
  watch: {
    "$route.params.appid"(id) {
      if (id && id !== this.appid) {
        this.appid = id;
        this.setBreadcrumb();
        this.loadIllegal();
      }
    },
  },
  methods: {
    setBreadcrumb() {
      this.items = [
        { text: this.$t("menuitems.micoapp.text"), href: "/" },
        { text: this.$t("menuitems.icp.micoapp.list"), href: "/micoapp" },
        {
          text: this.$t("menuitems.icp.micoapp.info"),
          href: `/micoapp/${this.appid}`,
        },
        { text: "违规与申诉", active: true },
      ];
    },
    cmpHeaders() {
      return this.userinfo && this.userinfo.openid
        ? { Openid: this.userinfo.openid }
        : {};
    },
    timeOrDash(ts) {
      if (ts == null || ts === "") return "—";
      const n = Number(ts);
      if (Number.isNaN(n)) return String(ts);
      const d = new Date(n * 1000);
      return Number.isNaN(d.getTime()) ? String(ts) : d.toLocaleString("zh-CN");
    },
    async loadIllegal() {
      if (!this.appid) return;
      this.illegalLoading = true;
      this.illegalErr = "";
      const payload = { action: "getIllegalRecords", appid: this.appid };
      if (this.dateRange && this.dateRange.length === 2) {
        payload.start_time = Math.floor(this.dateRange[0].getTime() / 1000);
        payload.end_time = Math.floor(this.dateRange[1].getTime() / 1000);
      }
      try {
        const res = await this.$axios.post(COMPONENT_API, payload, {
          headers: this.cmpHeaders(),
        });
        const d = res.data || {};
        if (Number(d.errcode) === 0) {
          this.illegalRecords = Array.isArray(d.records) ? d.records : [];
        } else {
          this.illegalRecords = [];
          this.illegalErr = d.errmsg || `错误码 ${d.errcode}`;
        }
      } catch (e) {
        console.error(e);
        this.illegalRecords = [];
        this.illegalErr = "请求失败";
      } finally {
        this.illegalLoading = false;
      }
    },
    openAppeal(row) {
      const id = row && row.illegal_record_id;
      if (!id) return;
      this.currentIllegalId = id;
      this.appealDialogVisible = true;
      this.loadAppeal(String(id));
    },
    async loadAppeal(illegalRecordId) {
      this.appealLoading = true;
      this.appealErr = "";
      this.appealRecords = [];
      try {
        const res = await this.$axios.post(
          COMPONENT_API,
          {
            action: "getAppealRecords",
            appid: this.appid,
            illegal_record_id: illegalRecordId,
          },
          { headers: this.cmpHeaders() }
        );
        const d = res.data || {};
        if (Number(d.errcode) === 0) {
          this.appealRecords = Array.isArray(d.records) ? d.records : [];
        } else {
          this.appealErr = d.errmsg || `错误码 ${d.errcode}`;
        }
      } catch (e) {
        console.error(e);
        this.appealErr = "请求失败";
      } finally {
        this.appealLoading = false;
      }
    },
    appealStatusText(s) {
      const m = {
        1: "正在处理",
        2: "申诉不通过",
        3: "申诉通过",
        4: "申诉已撤销",
      };
      const n = Number(s);
      return m[n] != null ? m[n] : String(s ?? "—");
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <div class="d-flex flex-wrap align-items-center mb-3">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            size="small"
            class="mr-2 mb-2"
            clearable
          />
          <el-button
            type="primary"
            size="small"
            :loading="illegalLoading"
            @click="loadIllegal"
          >
            查询
          </el-button>
        </div>
        <el-alert
          v-if="illegalErr"
          :title="illegalErr"
          type="error"
          show-icon
          class="mb-3"
          :closable="false"
        />
        <el-table
          v-loading="illegalLoading"
          :data="illegalRecords"
          stripe
          size="small"
          style="width: 100%"
        >
          <el-table-column
            prop="illegal_record_id"
            label="记录 ID"
            min-width="120"
            show-overflow-tooltip
          />
          <el-table-column label="处罚时间" width="168">
            <template slot-scope="scope">
              {{ timeOrDash(scope.row.create_time) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="illegal_reason"
            label="违规原因"
            min-width="140"
            show-overflow-tooltip
          />
          <el-table-column
            prop="illegal_content"
            label="违规内容"
            min-width="160"
            show-overflow-tooltip
          />
          <el-table-column
            prop="rule_name"
            label="规则"
            min-width="120"
            show-overflow-tooltip
          />
          <el-table-column label="规则链接" min-width="88">
            <template slot-scope="scope">
              <a
                v-if="scope.row.rule_url"
                :href="scope.row.rule_url"
                target="_blank"
                rel="noopener noreferrer"
              >
                查看
              </a>
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="openAppeal(scope.row)"
              >
                申诉记录
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <p
          v-if="!illegalLoading && !illegalErr && illegalRecords.length === 0"
          class="text-muted small mt-2 mb-0"
        >
          暂无违规处罚记录（或时间范围内无数据）。
        </p>
      </div>
    </div>

    <el-dialog
      title="申诉记录"
      :visible.sync="appealDialogVisible"
      width="720px"
      append-to-body
      @closed="appealErr = ''"
    >
      <p class="text-muted small mb-2">
        违规记录 ID：<strong>{{ currentIllegalId || "—" }}</strong>
      </p>
      <el-alert
        v-if="appealErr"
        :title="appealErr"
        type="error"
        show-icon
        class="mb-2"
        :closable="false"
      />
      <el-table
        v-loading="appealLoading"
        :data="appealRecords"
        stripe
        size="small"
        max-height="360"
      >
        <el-table-column prop="appeal_record_id" label="申诉单 ID" width="110" />
        <el-table-column label="申诉时间" width="168">
          <template slot-scope="scope">
            {{ timeOrDash(scope.row.appeal_time) }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            {{ appealStatusText(scope.row.appeal_status) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="punish_description"
          label="处罚说明"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column
          prop="audit_reason"
          label="审核理由"
          min-width="120"
          show-overflow-tooltip
        />
        <el-table-column label="审核时间" width="168">
          <template slot-scope="scope">
            {{ timeOrDash(scope.row.audit_time) }}
          </template>
        </el-table-column>
      </el-table>
      <p
        v-if="
          !appealLoading && !appealErr && appealRecords.length === 0
        "
        class="text-muted small mt-2 mb-0"
      >
        暂无申诉记录。
      </p>
    </el-dialog>
  </Layout>
</template>
